import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ITourenQueryShapes, ITourenResponse, TourenQueryFilterConfig } from 'fa-kt.types';
import { TourenService } from '../service';

@Component({
  selector: 'fa-kt-touren-filter',
  templateUrl: './touren-filter.component.html',
  styleUrls: ['./touren-filter.component.css'],
})
export class TourenFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public TourenFilterConfig: IFilterConfig<ITourenResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public touren: TourenService,
  ) {
    this.TourenFilterConfig = TourenQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
  }

  ngOnInit() {
    this.subscriptions.push(
      this.touren.shapes$.subscribe((shapes: ITourenQueryShapes | undefined) => {
        if (!shapes) return;
        Object.entries(shapes)
          .filter(([key]) => key !== 'id' && (shapes as any)[key])
          .forEach(([key]) => this.shape(key, (shapes as any)[key]));
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.TourenFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.TourenFilterConfig[index].selections = shapes;
  }
}
